import { Pipe, PipeTransform } from "@angular/core";
import { Country } from "app/core/countries/model/country";
@Pipe({
  name: "countryCodesToNames",
  pure: true,
})
export class CountryCodesToNamesPipe implements PipeTransform {
  transform(countryCodes: string[], countries?: Country[]): any {
    let result = [];
    countryCodes.forEach((code) => {
      const country = countries.find(
        (c) => c.code.toUpperCase() === code.toUpperCase()
      );
      result.push(country ? country.name : code);
    });
    return result.join(", ");
  }
}
